<template>
    <div>
        <vs-chip v-for="service_id of service_id_list" :key="service_id">{{ getServiceIdToName(service_id) }}</vs-chip>
    </div>
</template>

<script>
export default {
	name: "ProvidersExpertiseChips",
	props: {
		services: Array,
		service_id_list: Array,
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
		};
	},
	created() {
	},
	watch: {
		service_id_list: function() {
			//console.log("this.service_id_list");
			//console.log(this.service_id_list);
		}
	},
	methods: {

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			service_name = service.name;
			// if(this.providerCount == this.providerCountTarget) this.forceRerenderExpertises()
			return service_name;
		},

		/**
		 * Create jsx chips to display
		 * @param {Array} service_id_list - List of service ids to create chip for
		 * @return {String} - JSX of services' chips
		 */
		createChips(service_id_list){
			/*
			 *  const vueComponent = new Vue({
			 *  template: '<vs-chip v-for="service_id in service_id_list" :key="service_id">{{ getServiceIdToName(service_id) }}</vs-chip>',
			 *  methods: {
			 *    domything() {
			 *      //console.log('Method was called')
			 *    }
			 *  }
			 *  });
			 *  return vueComponent.$mount("#chips").$el;
			 * ----------------------------
			 */
			let chips;
			// <vs-chip v-for="service_id in provider.service_id_list" :key="service_id">{{getServiceIdToName(service_id)}}</vs-chip>

			if(service_id_list === undefined) return "";

			for(let service_id in service_id_list){
				let service_name = this.getServiceIdToName(service_id);
				chips += <vs-chip>{{service_name}}</vs-chip>;
			}
			return chips;
		},
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}
</style>
